import styled from 'styled-components';
import { typography } from '../../shared/constants/theme';
import colors from '../../shared/constants/color';
import { textSM } from '../../shared/constants/textStyles';
import { getWiserTheme } from '../../shared/theme/wiserTheme';

export const StyledCardContainer = styled.div<{
  $cardStyle: "white" | "neutral" | "aiWhite" | "aiNeutral";
  $darkModeActive?: boolean;
}>`
display: flex;
flex-direction: column;
gap: 16px;
padding: 16px;
height: 100%;
min-height: 0;
overflow: hidden;
font-family: ${typography.fontFamily};
background: ${({ $cardStyle, $darkModeActive }) => {
        const t = getWiserTheme(!!$darkModeActive);
        switch ($cardStyle) {
            case "white":
                return $darkModeActive ? t.surface : "white";
            case "neutral":
                return $darkModeActive ? t.surfaceMuted : colors.neutral.N10;
            case "aiNeutral":
                return $darkModeActive
                    ? `linear-gradient(${t.surfaceMuted}, ${t.surfaceMuted}) padding-box, ${colors.aiLinearGradient} border-box`
                    : `linear-gradient(${colors.neutral.N10}, ${colors.neutral.N10}) padding-box, ${colors.aiLinearGradient} border-box`;
            case "aiWhite":
                return $darkModeActive
                    ? `linear-gradient(${t.surface}, ${t.surface}) padding-box, ${colors.aiLinearGradient} border-box`
                    : `linear-gradient(white, white) padding-box, ${colors.aiLinearGradient} border-box`;
            default:
                return $darkModeActive ? t.surfaceMuted : colors.neutral.N10;
        }
    }};
border-radius: 8px;
border: 1px solid ${({ $cardStyle, $darkModeActive }) => {
        const t = getWiserTheme(!!$darkModeActive);
        switch ($cardStyle) {
            case "white":
            case "neutral":
                return $darkModeActive ? t.borderStrong : colors.neutral.N40;
            case "aiNeutral":
            case "aiWhite":
                return "transparent";
            default:
                return $darkModeActive ? t.borderStrong : colors.neutral.N40;
        }
    }};
`;

export const StyledCardHeader = styled.div<{ $clickable?: boolean }>`
display: flex;
align-items: center;
justify-content: space-between;
gap: 12px;
cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
transition: all 0.2s ease;
`;

export const StyledIconWrapper = styled.div`
display: flex;
align-items: center;
justify-content: center;
width: 24px;
height: 24px;
flex-shrink: 0;

svg {
  width: 24px;
  height: 24px;
}
`;

export const StyledIconTitleContainer = styled.div`
display: flex;
align-items: center;
gap: 12px;
`;

export const StyledCardTitle = styled.span<{
  $titleStyle: "default" | "aiGradient";
  $darkModeActive?: boolean;
}>(({ $titleStyle, $darkModeActive }) => ({
    ...textSM(
      500,
      $titleStyle === "aiGradient"
        ? "aiGradient"
        : $darkModeActive
          ? getWiserTheme(true).textPrimary
          : colors.neutral.N700,
    ),
}));

export const StyledSeparator = styled.hr<{ $darkModeActive?: boolean }>`
margin: 0;
border: none;
border-top: 1px solid ${({ $darkModeActive }) =>
  $darkModeActive ? getWiserTheme(true).borderStrong : colors.neutral.N40};
width: 100%;
`;

export const StyledCardContent = styled.div<{ $darkModeActive?: boolean }>`
display: flex;
flex-direction: column;
gap: 16px;
min-height: 0;
flex: 1;
overflow-y: auto;
overflow-x: hidden;
padding-right: 4px;
&::-webkit-scrollbar {
    width: 4px;
}
&::-webkit-scrollbar-track {
    background: transparent;
}
&::-webkit-scrollbar-thumb {
    background: ${({ $darkModeActive }) =>
      $darkModeActive ? getWiserTheme(true).textMuted : colors.neutral.N40};
    border-radius: 3px;
    &:hover {
        background: ${({ $darkModeActive }) =>
          $darkModeActive ? getWiserTheme(true).textSecondary : colors.neutral.N50};
    }
}
`;

export const StyledCardFooter = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
flex-shrink: 0;

/* Tek child varsa sağa yaslı yap */
& > *:only-child {
    margin-left: auto;
}
`;